<template lang="pug">
.post-card__footer
  post-author.post-card__author(
    :author="author"
  )
</template>

<script>
import PostAuthor from '@/components/post/post-author'

export default {
  name: 'post-card__footer',
  components: {
    PostAuthor,
  },
  props: {
    post: {
      type: Object,
    },
    author: {
      type: Object,
    },
  },
  computed: {
    replies() {
      return this.post.replies || []
    },
  },
}
</script>

<style lang="sass">
.post-card__footer
  display: flex
  justify-content: space-between
  position: absolute
  bottom: 0
  left: 0
  width: 100%
  padding: 1rem

.post-card__author 
  .post-author__posted-by
    background-image: linear-gradient(white, white)
    background-size: 100% 100%
    background-repeat: no-repeat
    margin-left: 0.5rem

  .post-author__avatar
    border: 0.125rem solid white
    box-sizing: content-box

.post-reply-count__wrapper
  position: relative

.post-card__reply-count
  --reply-count-padding-v: .2rem
  --reply-count-padding-h: .5rem
  --reply-count-border-width: 1px
  --reply-count-border-radius: 6px

.post-card__reply-count
  font-size: 0.8rem
  align-self: center

  .post-reply-count
    background-color: white
    line-height: 1
    border-radius: var(--reply-count-border-radius)
    border: var(--reply-count-border-width) solid var(--base-color)
    padding: var(--reply-count-padding-v) var(--reply-count-padding-h)
    
  
    &:before,
    &:after
      display: block
      content: ""
      width: 0
      height: 0
      position: absolute
      border-style: solid

    &:before
      top: calc((var(--reply-count-padding-v) * 2) + var(--reply-count-border-width) + 1em)
      right: calc(var(--reply-count-border-radius) + 1px)
      border-width: 4px
      border-color: var(--base-color) transparent transparent var(--base-color)

    &:after
      top: calc((var(--reply-count-padding-v) * 2) + 1em)
      right: calc(var(--reply-count-border-radius) + 2px)
      border-width: 3px
      border-color: white transparent transparent white


.post-card:not(.--media)
  .post-card__footer
    padding-top: 0
    background-color: white

    &:before
      content: ''
      display: block
      position: absolute
      z-index: 10
      left: 0
      right: 0
      top: -3rem
      height: 3rem
      background-image: linear-gradient(180deg, rgba(255,255,255,0), white)
      
</style>